import { render, staticRenderFns } from "./history-tap.vue?vue&type=template&id=4dd2d95c"
import script from "./history-tap.vue?vue&type=script&lang=js"
export * from "./history-tap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports